import * as Sentry from "@sentry/react";

// Sentry error monitoring. The DSN is a public, write-only identifier and is
// safe to ship in the client bundle. We only initialize in production builds
// to keep dev/preview noise-free. Release tagging uses VITE_APP_VERSION when
// available (set during CI builds).
const SENTRY_DSN =
  (import.meta.env.VITE_SENTRY_DSN as string | undefined) ??
  "https://67a49989e0b1c09ca46fc83ff5d7200a@o4511542141321216.ingest.us.sentry.io/4511542150692864";

export function initSentry() {
  if (import.meta.env.MODE !== "production") return;
  if (!SENTRY_DSN) return;
  Sentry.init({
    dsn: SENTRY_DSN,
    release: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "unknown",
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}